import { Dispatch, SetStateAction, useState, useImperativeHandle, Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { Resettable } from '@/models/Resettable';
import { FilterState } from '../FiltersArea';
import OptionsRangeFilter from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';

interface CurrencyFilterProps {
  setFilterState: Dispatch<SetStateAction<FilterState>>;
  ref?: Ref<Resettable>;
}

const CurrencyFilter = ({ setFilterState, ref }: CurrencyFilterProps) => {
  const { t } = useTranslation();
  const [checkedOptions, setCheckedOptions] = useState<Set<string>>(new Set());

  const options = [
    {
      id: 'ils',
      label: 'shekel',
      checked: checkedOptions.has('ils'),
      currency: ['ILS'],
    },
    {
      id: 'usd',
      label: 'usd',
      checked: checkedOptions.has('usd'),
      currency: ['USD'],
    },
  ];

  const handleOptionChange = (optionId: string) => {
    const newCheckedOptions = new Set(checkedOptions);
    if (newCheckedOptions.has(optionId)) {
      newCheckedOptions.delete(optionId);
    } else {
      newCheckedOptions.add(optionId);
    }
    setCheckedOptions(newCheckedOptions);

    const selectedValues = options.filter((opt) => newCheckedOptions.has(opt.id)).flatMap((opt) => opt.currency);

    setFilterState((prev) => ({
      ...prev,
      currencies: selectedValues,
    }));
  };

  const handleSelectAllChange = (selectAll: boolean) => {
    const newCheckedOptions = selectAll ? new Set(options.map((option) => option.id)) : new Set<string>();
    setCheckedOptions(newCheckedOptions);

    const selectedValues = selectAll ? options.flatMap((opt) => opt.currency) : [];

    setFilterState((prev) => ({
      ...prev,
      currencies: selectedValues,
    }));
  };

  useImperativeHandle(ref, () => ({
    reset: () => {
      setCheckedOptions(new Set());
    },
  }));

  return (
    <OptionsRangeFilter
      title="currency"
      filterType="options"
      options={options.map(({ id, label, checked }) => ({ id, label: t(label), checked }))}
      onOptionChange={handleOptionChange}
      onSelectAllChange={handleSelectAllChange}
      selectionType="checkbox"
    />
  );
};

export default CurrencyFilter; 